<template>
  <div class="modalWrapper-js" >
    <div class="modal-js">
      <form :action="route" method="POST" class="main_content_form" @submit.prevent="sendForm">
        <input type="hidden" name="_token" :value="csrf" />
        <label v-if="elem==='pages'" for="name" class="field_edit_label"> Nom de la page</label>
        <label v-else for="name" class="field_edit_label"> Nom de l'article</label>
        <input @keydown.esc="$emit('close')" v-focus type="text" name="name" class="field_edit_input" required id="name" v-model="pageName"/>
        <button type="submit" class="form_content_submit"> Valider </button>
      </form>
    </div>
  </div>
</template>

<script>
  window.axios = require('axios')
  let focus = {
    inserted: function (el) {
      el.focus()
    }
  }
  export default {
    props: {
      route: String,
      csrf: String,
      elem: String,
      dataListPage: Array,
      dataVisible: Boolean
    },
    directives: {focus},
    data() {
      return {
        pageName: '',
        listPage: this.dataListPage,
        visible: this.dataVisible
      }
    },
    methods: {
      sendForm: function(){
        axios.post(this.route, {
          name: this.pageName,
          responseType: 'json'
        }).then(({data}) => {
          this.listPage.push(data)
          this.$emit('close')
        })
      }
    },

  }
</script>
